module.exports = __webpack_public_path__ + "static/2016-garage-c20bf63e985cc0e7d5425f27b281a256.jpg";